import Customer from '@/models/Customer/Customer';

export default class CustomerFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.code = '';
		this.name = '';
		this.officeAddressMultiple = '';
		this.officePhoneNumber = '';
		this.stockLevel = '';
		this.destination = '';
		this.contactPerson = '';
		this.contactPersonPhoneNumber = '';
		this.contactPersonEmail = '';
		this.codeSuratJalan = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			code : '0',
			name : '0',
			officeAddressMultiple : '0',
			officePhoneNumber : '0',
			stockLevel : '0',
			destination : '0',
			contactPerson : '0',
			contactPersonPhoneNumber : '0',
			contactPersonEmail : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
			codeSuratJalan : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}